export const ImagePath = {
  postieBot: require("./images/Postie.png"),
  EmmaLogo: require("./images/amma-img.png"),
  emmaBot: require("./images/bot.png"),
  dummyUser: require("./images/dummy-user.jpg"),
  filter: require("./images/filter.svg").default,
  alert: require("./images/alert.svg").default,
  boatDummy: require("./images/boatDummy.png"),
  searchIcon: require("./images/search.svg").default,
  sendLogo: require("./images/sendLogo.svg").default,
  searchIcon2: require("./images/search2.svg").default,
  logoOnship: require("./images/onshipDomain/logo-onship.png"),
  poweredText: require("./images/powered-text.svg").default,
  toogleBar: require("./images/toogleBar.svg").default,
  keypadLogo: require("./images/keypad.svg").default,
  frontMLoader: require("./images/logo-small.gif"),
  dotLoaderGif: require("./images/Loft_loading.gif"),
  eyeIcon: require("./images/eye-icon.svg").default,
  palCareLogo: require("./images/PALCare.png"),
  mariAppLogo: require("./images/mariAppLogo.svg").default,
  floatImage: require("./images/floatingBot.png"),
  HomeLogo: require("./images/menu-icons-1.svg").default,
  FavoriteLogo: require("./images/menu-icons-2.svg").default,
  ActivityLogo: require("./images/menu-icons-3.svg").default,
  ContactLogo: require("./images/menu-icons-4.svg").default,
  GroupLogo: require("./images/menu-icons-5.svg").default,
  MarketplaceLogo: require("./images/menu-icons-6.svg").default,
  searchmobile: require("./images/search-icon.svg").default,
  sendbtn: require("./images/send.svg").default,
  downloadbn: require("./images/download.svg").default,
  menuIcon: require("./images/Menu-icon.svg").default,
  StationSatcomNewLogo: require("./images/StationSatcomNewLogo.png"),
  newStationSatcomBGM: require("./images/newStationSatcomBGM.png"),
  palCareLoginBGM: require("./images/right-login-bg.png"),
  callIcon: require("./images/call-icon.png"),
  editIcon: require("./images/editIcon.svg").default,
  chatIcon: require("./images/chat-icon.svg").default,
  searchMaind: require("./images/search-main-d.svg").default,
  invite: require("./images/get-data.svg").default,
  profileCamera: require("./images/profile-camera.svg").default,
  closeIcon: require("./images/closeIcon.svg").default,
  myProfileReset: require("./images/myprofile_reset.svg").default,
  downArrow: require("./images/downArrow.svg").default,
  sadCloud: require("./images/sad-cloud.png"),
  eWallet_plus_icon: require("./images/plus-icon@3x.png"),
  emptyTable: require("./images/emptyTable.png"),
  forgotBGBanner: require("./images/forgotBGbanner.png"),
  changePasswordBanner: require("./images/changePasswordBanner.png"),
  signupRightImg: require("./images/register-right-img.png"),
  messageLogo: require("./images/message.svg").default,
  addPlusIcon: require("./images/addPlusIcon.svg").default,
  editGroupLogo: require("./images/editGroupLogo.svg").default,
  exitGroupLogo: require("./images/exitGroupLogo.svg").default,
  resultsNotFound: require("./images/resultsNotFound.svg").default,
  searchResult: require("./images/search-result.svg").default,
  unreadMessage: require("./images/unread-msg.svg").default,
  noFavourites: require("./images/no-favourites.svg").default,
  messageScreenEmpty: require("./images/messageScreenEmpty.svg").default,
  people: require("./images/people.svg").default,
  members: require("./images/addMembers.svg").default,
  options: require("./images/option.svg").default,
  infoicon: require("./images/info-icon.svg").default,
  removeicon: require("./images/remove-icon.svg").default,
  dotsWhite: require("./images/whitedots.svg").default,
  delgroup: require("./images/del.svg").default,
  xcircle: require("./images/x-circle .svg").default,
  groupImg: require("./images/thumbnal.svg").default,
  seamedixsLogo: require("./images/seamedixsDomain/seamedixsLogo.svg").default,

  //frontm Domain 
  smalllogo: require("./images/frontmDomain/smallLogo.png"),
  frontmLogo: require("./images/frontmDomain/frontmBiggerTMLogo.svg").default,
  frontmBanner: require("./images/frontmDomain/frontmBanner.png"),
  //vikand Domain 
  VikandLogo: require("./images/vikandDomain/vikandLogo.png"),
  vikandLoginBanner: require("./images/vikandDomain/vikand_Login_banner.png"),

  //seamedix Domain 
  seamedixLoginBanner: require("./images/seamedixsDomain/seamedixLoginBanner.png"),

  //intelsat Domain 
  intelsatLogin: require("./images/intelsatDomain/IntelsatLogo.png"),
  intelsatLoginBanner: require("./images/intelsatDomain/IntelsatBGM.jpeg"),

  //form fields
  dropdownIcon: require("./images/formFieldsIcons/dropdown.png"),
  buttonField: require("./images/formFieldsIcons/button.png"),
  checkboxField: require("./images/formFieldsIcons/checkbox.png"),
  datePickerDefaultIcon: require("./images/formFieldsIcons/date-picker-default-icon.png"),
  dateAndTimePickerField: require("./images/formFieldsIcons/datepickerIcon.png"),
  datePickerField: require("./images/formFieldsIcons/date.png"),
  emailField: require("./images/formFieldsIcons/emailcon.png"),
  fileAttachmentField: require("./images/formFieldsIcons/fileAttachment.png"),
  calenderIcon: require("./images/formFieldsIcons/icon-cl.png"),
  multiSelectField: require("./images/formFieldsIcons/multiSelect.png"),
  radioButtonField: require("./images/formFieldsIcons/radioButton.png"),
  searchInputField: require("./images/formFieldsIcons/serachinput.png"),
  textAreaField: require("./images/formFieldsIcons/textArea.png"),
  textField: require("./images/formFieldsIcons/textIcon.png"),
  uploadImageField: require("./images/formFieldsIcons/uploadImage.png"),
  uploadVideoField: require("./images/formFieldsIcons/uploadVideo.png"),
  radioBtnIcon: require("./images/radioBtnIcon.png"),
};